import {schema} from "../module/config/schema";
import {EditorState} from "prosemirror-state";
import {getParentWithNodeTypePos} from "./getParentWithNodeTypePos";
import {ResolvedPos} from "prosemirror-model";

export const findTablePos = (state: EditorState) => {
    const {$from} = state.selection;
    return getParentWithNodeTypePos($from, schema.nodes.table);
}

export const findTablePosByTargetPos = ($from: ResolvedPos) => {
    return getParentWithNodeTypePos($from, schema.nodes.table);
}